<template>
  <v-cotainer fluid grid-list-md fill-height>
    <v-layout row wrap>
      <v-flex xs12 sm12 md12>
        <v-toolbar class="primary white--text">
          <v-toolbar-title class="headline text-xs-center">
            Product Offers Management
          </v-toolbar-title>
          <v-spacer></v-spacer>
        </v-toolbar>

        <v-data-table
          :headers="productOffersHeader"
          :items="productListByBrand"
          hide-actions
          class="elevation-1 dashboardHead"
        >
          <template slot="items" slot-scope="props">
            <td>
              {{ props.item.name }}
            </td>
            <td>
              <v-btn icon class="mx-0" @click="editProduct(props.item)">
                <v-icon color="pink">edit</v-icon>
              </v-btn>
            </td>
          </template>
          <template slot="no-data">No Items</template>
        </v-data-table>
      </v-flex>
    </v-layout>

    <!-- Start Product Set Dialog -->
    <v-dialog v-model="productOfferDialog" persistent max-width="1000px">
      <v-card persistent v-if="selectedProduct['.key']">
        <v-card-title class="primary white--text">
          <span class="headline">Create Product Set</span>
          <v-spacer></v-spacer>
        </v-card-title>

        <v-card-text>
          <v-container grid-list-md>
            <v-layout wrap>
              <v-flex xs10 sm10 md10>
                Add Update Offers for {{ selectedProduct.name }}
              </v-flex>

              <v-flex xs2 sm2 md2>
                <v-btn
                  icon
                  color="primary"
                  v-if="selectedProduct.offers.length == 0"
                  @click="addProd()"
                >
                  <v-icon>add_circle</v-icon>
                </v-btn>
              </v-flex>
              <v-flex xs12 sm12 md12>
                <v-layout
                  wrap
                  v-for="(offer, index) in selectedProduct.offers"
                  :key="index"
                >
                  <v-flex xs12 md2>
                    <v-text-field
                      type="number"
                      v-model.number="offer.minQuantity"
                      label="Min Quantity"
                    >
                    </v-text-field>
                  </v-flex>
                  <v-flex xs12 md2>
                    <v-text-field
                      type="number"
                      v-model.number="offer.offerQuantity"
                      label="Offer Free Quantity"
                    >
                    </v-text-field>
                  </v-flex>
                  <v-flex xs12 md3>
                    <v-menu
                      :close-on-content-click="false"
                      v-model="datepicker1[index]"
                      :nudge-right="40"
                      lazy
                      transition="scale-transition"
                      offset-y
                      full-width
                      min-width="290px"
                    >
                      <v-text-field
                        slot="activator"
                        v-model="offer.startDate"
                        label="Offer Start Date"
                        prepend-icon="event"
                        readonly
                      ></v-text-field>
                      <v-date-picker
                        v-model="offer.startDate"
                        @input="datepicker1[index] = false"
                      ></v-date-picker>
                    </v-menu>
                  </v-flex>
                  <v-flex xs12 md3>
                    <v-menu
                      :close-on-content-click="false"
                      v-model="datepicker2[index]"
                      :nudge-right="40"
                      lazy
                      transition="scale-transition"
                      offset-y
                      full-width
                      min-width="290px"
                    >
                      <v-text-field
                        slot="activator"
                        v-model="offer.endDate"
                        label="Offer End Date"
                        prepend-icon="event"
                        readonly
                      ></v-text-field>
                      <v-date-picker
                        v-model="offer.endDate"
                        @input="datepicker2[index] = false"
                      ></v-date-picker>
                    </v-menu>
                  </v-flex>
                  <v-flex xs12 md2>
                    <v-btn
                      icon
                      color="primary"
                      v-if="index == selectedProduct.offers.length - 1"
                      @click="addProd()"
                    >
                      <v-icon>add_circle</v-icon>
                    </v-btn>
                    <v-btn icon color="primary" @click="removeProd(index)">
                      <v-icon>cancel</v-icon>
                    </v-btn>
                  </v-flex>
                </v-layout>
              </v-flex>
            </v-layout>
          </v-container>
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="blue darken-1" @click="productOfferDialog = false" flat
            >Cancel</v-btn
          >
          <v-btn color="blue darken-1" @click="updateProduct()" flat
            >Update</v-btn
          >
        </v-card-actions>
      </v-card>
    </v-dialog>
  </v-cotainer>
</template>
<script>
import { createNamespacedHelpers } from "vuex";
const mapGlobalGetters = createNamespacedHelpers("Global")["mapGetters"];
const mapBuyerGetters = createNamespacedHelpers("Buyer")["mapGetters"];
export default {
  data() {
    return {
      productOfferDialog: false,
      productOffersHeader: [
        { text: "Product", value: "deposit - ID" },
        { text: "Edit", value: "edit" },
      ],
      selectedProduct: {
          offers : [],
      },
      datepicker1: [],
      datepicker2: [],
    };
  },
  created() {
    this.$bindAsArray(
      "products",
      this.$root.$firebaseRefs.products
        .orderByChild("brand")
        .equalTo(this.selectedBrand)
    );
  },
  computed: {
    ...mapGlobalGetters(["selectedBrand", "finYear"]),
    ...mapGlobalGetters({ units: "productUnit" }),
    productListByBrand() {
      return this.products.filter((item) => {
        return (
          item["brand"] === this.selectedBrand &&
          (item.openingDate
            ? item.openingDate >= this.finYear.start &&
              item.openingDate <= this.finYear.end
            : true)
        );
      });
    },
  },
  methods: {
    updateProduct() {
      this.selectedProduct.offers.map((item, index) => {
        (this.selectedProduct.offers[index].startDate = new Date(
          item.startDate
        ).getTime()),
          (this.selectedProduct.offers[index].endDate = new Date(
            item.endDate
          ).getTime());
      });
      let key = this.selectedProduct[".key"];
      delete this.selectedProduct[".key"];
      this.$root.$firebaseRefs.products
        .child(key)
        .set(this.selectedProduct)
        .then((snap) => {
          this.productOfferDialog = false;
          this.selectedProduct = {
              offers : [],
          };
        });
    },
    editProduct(item) {
      this.selectedProduct = item;
      if (!this.selectedProduct.offers) {
        this.selectedProduct.offers = [];
      } else {
        this.selectedProduct.offers.map((item, index) => {
          this.selectedProduct.offers[index].startDate = new Date(
            item.startDate
          )
            .toISOString()
            .substr(0, 10);
          this.selectedProduct.offers[index].endDate = new Date(item.endDate)
            .toISOString()
            .substr(0, 10);
        });
      }
      this.productOfferDialog = true;
    },
    addProd() {
      this.selectedProduct.offers.push({
        minQuantity: 1,
        offerQuantity: 1,
        startDate: new Date().toISOString().substr(0, 10),
        endDate: new Date().toISOString().substr(0, 10),
      });
      this.selectedProduct = {...this.selectedProduct}
    },
    removeProd(index) {
      this.selectedProduct.offers.splice(index, 1);
    },
  },
};
</script>




// WEBPACK FOOTER //
// src/components/Settings/ProductOffers/ProductOffers.vue